export enum CompareReference {
  Match = 'Match',
  NotMatch = 'NotMatch',
  Unknown = 'Unknown',
}
